import { render } from "./startup-experience.vue?vue&type=template&id=06434371&ts=true"
import script from "./startup-experience.vue?vue&type=script&lang=ts"
export * from "./startup-experience.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__